import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { forkJoin, Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { ClientRoleCheck, ClientRoleCheckResult } from '../models/client-role-check';
import { first, map, mergeMap } from 'rxjs/operators';
import { AclService } from '../services/acl.service';

@Injectable({
  providedIn: 'root'
})
export class MinRoleCheckGuard {
  constructor(
    private aclService: AclService,
    private authService: AuthService,
    private router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.hasMinRole(route.data);
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.hasMinRole(childRoute.data);
  }

  private hasMinRole(routeData: any): Observable<boolean | UrlTree> {
    return this.authService.isLoggedIn().pipe(
      first(),
      mergeMap(loggedIn => {
        if (loggedIn) {
          const userId = this.authService.user.UserId;
          const roles: string[] = routeData.roles;
          if (roles.length === 0) {
            return of(true);
          }
          const models: ClientRoleCheck[] = [];
          roles.forEach(role => {
            models.push({
              UserId: userId,
              Role: role,
              OfficeGroup: null,
              ClientGroup: null,
              LocationGroup: null,
              DivisionGroup: null,
              DepartmentGroup: null
            });
          });
          const observables: Observable<{ roleCheck: ClientRoleCheck; passed: boolean }>[] = [];

          models.forEach(model => {
            const obs = this.aclService.HasMinimumRoleByName(userId, model.Role).pipe(
              map(result => {
                return { roleCheck: model, passed: result };
              })
            );
            observables.push(obs);
          });
          return forkJoin(observables).pipe(
            map(result => {
              if (result.some(x => x.passed)) return true;
              return this.router.parseUrl('/access-denied');
            })
          );
        } else {
          return of(this.router.parseUrl('/access-denied'));
        }
      })
    );
  }
}
